import Vue from 'vue';
import validate from './validate';

for (const key of Object.keys(validate)) {
  Vue.directive(`v-${key}`, validate[key]);
}
